// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2Tai1","savePackageButton":"ClientWallet_savePackageButton__VYX5f"};